import * as types from './types';

export function validateUserRequest(payload) {
    return {
        type: types.VALIDATION_USERNAME_REQUEST,
        payload
    }
}
export function validateUserResponse(response) {
    return {
        type: types.VALIDATION_USERNAME_RESPONSE,
        response
    }
}
export function validateUserFailed(response) {
    return {
        type: types.VALIDATION_USERNAME_FAILED,
        response
    }
}
export function checkPatientExistsRequest(payload) {
    return {
        type: types.CHECK_PATIENT_EXISTS_REQUEST,
        payload
    }
}
export function checkPatientExistsResponse(response) {
    return {
        type: types.CHECK_PATIENT_EXISTS_RESPONSE,
        response
    }
}
export function checkPatientExistsFailed(response) {
    return {
        type: types.CHECK_PATIENT_EXISTS_FAILED,
        response
    }
}
export function saveUsername(response) {
    return {
        type: types.SAVE_USERNAME,
        response
    }
}
export function verify2faCodeRequest(payload) {
    return {
        type: types.VERIFY_2FACODE_REQUEST,
        payload
    }
}
export function verify2faCodeResponse(response) {
    return {
        type: types.VERIFY_2FACODE_RESPONSE,
        response
    }
}
export function verifyCodeResponse(response) {
    return {
        type: types.VERIFY_CODE_RESPONSE,
        response
    }
}
export function verify2faCodeFailed(response) {
    return {
        type: types.VERIFY_2FACODE_FAILED,
        response
    }
}
export function validatePatientEmailPhone(payload) {
    return {
        type: types.VALIDATE_PATIENT_EMAIL_PHONE,
        payload
    };
}
export function validatePatientEmailPhoneResponse(response) {
    return {
        type: types.VALIDATE_PATIENT_EMAIL_PHONE_RESPONSE,
        response,
    };
}
export function requestRegister(payload) {
    return {
        type: types.REGISTER_REQUEST,
        payload
    };
}
export function registerFailed() {
    return {
        type: types.REGISTER_FAILED,
    };
}
export function resetRegisterData() {
    return {
        type: types.RESET_REGISTER_DATA
    }
}
export function onErrorOccured(response) {
    return {
        type: types.ERROR_OCCURED,
        response
    };
}
export function enableLoader() {
    return {
        type: types.ENABLE_LOADER,
    };
}

export function disableLoader() {
    return {
        type: types.DISABLE_LOADER,
    };
}